module.exports = __webpack_public_path__ + "static/media/PDF_72.b958c2c5.pdf";